import { Typography } from "@circle-react-shared/uikit/Typography";
import type { Plan } from "@circle-react/types/Plan";

import { t } from "@/i18n-js/instance";
import {
  isAnnual,
  planAmountWithCurrencySymbolPrefix,
} from "@/react/helpers/planHelpers";
import { isCurrent } from "@/react/helpers/plansHelpers";

interface PlanMonthlyPriceProps {
  plan: Plan;
}

export const PlanMonthlyPrice = ({ plan }: PlanMonthlyPriceProps) => {
  const isCurrentPlan = isCurrent(plan.plan_action);
  const shouldShowStrikeThrough =
    plan.is_on_offer &&
    !isCurrentPlan &&
    plan.plan_coupon?.discounted_monthly_price;

  // Annual offers are discounted from monthly list pricing, so strike that
  const originalPrice =
    isAnnual(plan.interval) && plan.strike_through_price
      ? plan.strike_through_price
      : plan.display_base_monthly_amount;

  const displayPrice = shouldShowStrikeThrough
    ? planAmountWithCurrencySymbolPrefix(
        plan.plan_coupon?.discounted_monthly_price || "",
        plan.currency,
      )
    : plan.display_base_monthly_amount;

  return (
    <div className="flex flex-row items-center gap-1 align-middle">
      {shouldShowStrikeThrough && (
        <Typography.BodyMd
          weight="font-normal"
          color="text-tertiary"
          size="text-normal"
        >
          <span className="line-through">
            <span className="sr-only">
              {t(
                "pricing_plans.plan_settings.plan_selection.plan_selector.original_price",
              )}{" "}
            </span>
            {originalPrice}
          </span>
        </Typography.BodyMd>
      )}
      <Typography.TitleMd weight="font-bold">{displayPrice}</Typography.TitleMd>
      <Typography.BodyMd
        weight="font-normal"
        color="text-slate-700 dark:text-slate-300"
        size="text-sm"
      >
        {t(
          "pricing_plans.plan_settings.plan_selection.plan_selector.monthly_interval",
        )}
      </Typography.BodyMd>
    </div>
  );
};
